import React, { Component } from 'react';
import PropTypes from 'prop-types';

export function withScrollTop(WrappedComponent) {
	class WithScrollTop extends Component {
		componentDidMount() {
			if (window && window.scrollTo) {
				window.scrollTo(0, 0);
			}
		}

		componentDidUpdate(prevProps) {
			if (this.props.page && this.props.page !== prevProps.page && window && window.scrollTo) {
				window.scrollTo(0, 0);
			}
		}

		render() {
			return <WrappedComponent {...this.props} />;
		}
	}

	WithScrollTop.displayName = `withScrollTop(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
	WithScrollTop.propTypes = {
		page: PropTypes.string,
	};

	return WithScrollTop;
}
